module.exports = "/packs/media/images/icon-options-ecec05745f128cc42cb7e34f8194c5eb.png";